import Settings from '../view/Settings'
import NewsCard from '../view/NewsCard'

export const routes = [
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/news/edit/:id',
    name: 'NewsCard',
    component: NewsCard
  },

]